export enum PagesEndpoints {
  Homes = 'homes',
  Profile = 'profile',
  Scans = 'scans',
  Mandates = 'mandates',
  Bundles = 'bundles',
  Control = 'control',
  Classification = 'classification',
  Admin = 'admin',
}
